import { RouteObject } from 'react-router-dom';
import ErrorPage, { Page404 } from 'src/error-page';
import { DEFAULT_PUBLIC_ENTERPRISE_SIMULATOR_MKT_PATH, DEFAULT_PUBLIC_ENTERPRISE_SIMULATOR_PATH } from './constants';
import { lazyConReintento } from 'src/config/lazy-con-reintento';
import { diferida } from 'src/config/pagina-diferida';

// `constants.ts` se importa de forma normal a proposito: son las dos cadenas con las que se
// construyen los `path`, y esos hacen falta antes de que el router decida nada.
const PublicEnterpriseSimulatorView = lazyConReintento(() => import('./index'));

const paths = [`${DEFAULT_PUBLIC_ENTERPRISE_SIMULATOR_PATH}/:accessId?`, '/simulador-empresas/:accessId?', '/public-enterprise-simulator/:accessId?'];
const mktPaths = [`${DEFAULT_PUBLIC_ENTERPRISE_SIMULATOR_MKT_PATH}/:accessId?`];

const publicPersonSimulatorRoutes: RouteObject[] = [
  ...paths.map((path) => ({
    path,
    element: diferida(<PublicEnterpriseSimulatorView isMkt={false} />),
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: diferida(<PublicEnterpriseSimulatorView isMkt={false} />)
      },
      {
        path: '*',
        element: <Page404 />
      }
    ]
  })),
  ...mktPaths.map((path) => ({
    path,
    element: diferida(<PublicEnterpriseSimulatorView isMkt={true} />),
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: diferida(<PublicEnterpriseSimulatorView isMkt={true} />)
      },
      {
        path: '*',
        element: <Page404 />
      }
    ]
  }))
];

export default publicPersonSimulatorRoutes;
